import React, { Fragment } from 'react';
import { string } from 'prop-types';
import { UTLabel, WithLoading } from '@widergy/energy-ui';

import UTForm from 'app/components/UTForm';
import { appConfig } from 'config/customization';
import { genderField, documentNumberField, documentTypeField, emailField } from 'constants/fields';
import { message } from 'utils/stringUtils';

import styles from './styles.module.scss';

const recoverySteps =
  appConfig.signInMethod === 'documentType'
    ? message('Signin:recoveryStepsDocType')
    : message('Signin:recoveryStepsEmail');

const PasswordRecovery = ({ documentType, documentNumber }) => {
  const gender =
    appConfig.signIn.conditionalRequestGender &&
    documentType === 'dni' &&
    documentNumber >= appConfig.signIn.minDocNumber &&
    documentNumber <= appConfig.signIn.maxDocNumber
      ? [genderField]
      : [];

  const fields =
    appConfig.signInMethod === 'documentType'
      ? [documentTypeField, documentNumberField, ...gender]
      : [emailField];

  const fieldValues = { document_number: documentNumber, document_type: documentType };

  return (
    <Fragment>
      <UTLabel light darkGray className={styles.instructions}>
        {recoverySteps}
      </UTLabel>
      <UTForm fields={fields} fieldValues={fieldValues} fieldClasses={{ container: styles.noShrink }} />
    </Fragment>
  );
};

PasswordRecovery.propTypes = {
  documentType: string,
  documentNumber: string
};

export default WithLoading(props => props.loading)(PasswordRecovery);
